/* Barklie desktopmenu: "Shop" opent/sluit het paneel met een klik (volgens referentie),
   sluit bij Escape of een klik ernaast. */
if (!customElements.get('bk-desktop-nav')) {
  customElements.define(
    'bk-desktop-nav',
    class BkDesktopNav extends HTMLElement {
      connectedCallback() {
        this.toggles = [...this.querySelectorAll('.bk-dnav__toggle')];
        this.toggles.forEach((toggle) => toggle.addEventListener('click', () => this.toggle(toggle)));
        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.closeAll(true);
        };
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      toggle(toggle) {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (!isOpen) {
          toggle.setAttribute('aria-expanded', 'true');
          document.getElementById(toggle.getAttribute('aria-controls')).hidden = false;
          document.documentElement.classList.add('bk-mega-open');
        }
      }

      closeAll(returnFocus = false) {
        this.toggles.forEach((toggle) => {
          if (toggle.getAttribute('aria-expanded') === 'true' && returnFocus) toggle.focus();
          toggle.setAttribute('aria-expanded', 'false');
          document.getElementById(toggle.getAttribute('aria-controls')).hidden = true;
        });
        document.documentElement.classList.remove('bk-mega-open');
      }
    }
  );
}
